import { curry } from "ramda"
import { isString } from "../../validate"

export default curry((maxLength, { value: str }) => {
  if (!isString(str)) return false

  if (maxLength && (str.length <= 0 || str.length > maxLength)) return false

  const hasNoOtherCharactor = /^[a-zA-Z\d]*$/.test(str)
  if (!hasNoOtherCharactor) return false

  return true
})
